import React, { useState } from 'react';

import { Row, Col, Layout, Divider, Modal } from 'antd';
import Login from './Login';
import GraphicCard from "../../Components/GraphicCard";
import FiniatLogo from "../../Components/Graphics/FiniatLogo";
const { Content } = Layout;

const IA_LOGO = 'https://storage.googleapis.com/finiat-web-static-resources/platform-logos/ia.webp';
const IQ_LOGO = 'https://storage.googleapis.com/finiat-web-static-resources/platform-logos/iq.webp';

const EntryPortal = ({initialView, prospect}) => {
    const [view, setView] = useState(initialView || 'portal'); // Initial view set to 'title'
    const [isProspect, setIsProspect] = useState(prospect || false);
    const [isModalVisible, setIsModalVisible] = useState(false);

    const handleLogin = (prospectState) => {
        setIsProspect(prospectState);
        setView('login');
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <Layout style={{background:"var(--light-grey)"}}>
            {view === 'portal' && (
                <>
                <Content className={'p-6'} style={{background: 'var(--light-grey)'}}>
                    <div style={{textAlign:'center'}}>
                        <FiniatLogo />
                        <Divider/>
                        <Divider/>
                        <div className={'cursor'} style={{color: '#0033ff', fontWeight: '600', textTransform:'uppercase'}} onClick={showModal}>
                            Which should I pick?
                        </div>
                    </div>
                    <Divider/>
                    <Row className={'p-6'} justify={'center'}>
                        <Col span={'auto'} className={'mx-6'}>
                            <GraphicCard
                                imgUrl={IA_LOGO}
                                title="IA Platform"
                                description="For current advisors using FINIAT"
                                onClick={() => handleLogin(false)}
                                height={175}
                                width={175}
                                className={'large portal-card'}
                            />
                        </Col>
                        <Divider type={'vertical'} className={'mx-6'}/>
                        <Col span={'auto'} className={'mx-6'}>
                            <GraphicCard
                                imgUrl={IQ_LOGO}
                                title="FINIAT IQ"
                                description="For potential advisors thinking about using FINIAT"
                                onClick={() => handleLogin(true)}
                                height={175}
                                width={175}
                                className={'large portal-card'}
                            />
                        </Col>
                    </Row>
                    <Modal title="Platform Selection Guide" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                        <p>If you are an existing user, please choose the IA Platform.</p>
                        <p>If you are a new user, you should use the IQ Platform and enter the email the link was sent to.</p>
                    </Modal>
                </Content>
                </>
            )}
            {view === 'login' && (
                <Login isProspect={isProspect} onBack={() => setView('portal')} />
            )}
        </Layout>
    );
};

export default EntryPortal;
